import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import LoginContantData from "../../components/loginContantData/LoginContantData";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { handleDark } from "../../redux/layout";
import { Formik, ErrorMessage } from "formik";
import * as Yup from 'yup';
import { useNavigate, useLocation } from "react-router-dom";
import { BiPhone, BiUser, BiEnvelope, BiLoader, BiSolidMapPin, BiSun, BiMoon, BiRefresh } from "react-icons/bi";
import { makeRequest } from "../../utils/makeRequest";
import * as urls from '../../utils/urlConst';
import toastNotify from "../../utils/toastNotify";
import Textfield from "../../components/textField/TextField";
import HelpdeskIcon from "../../components/HelpdeskIcon";
import { exceptionLog, getBankData } from "../../utils/common";
import SelectField from "../../components/textField/SelectField";
import useRecaptchaV3 from "../../components/RecaptchaV3";
import { getCaptchaCode } from "../../apiService/apiService";
import RecaptchaV2 from "../../components/RecaptchaV2";


const Registration = () => {
  const isDark = useSelector((state: any) => state.layout.isDark);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const bankLogo = useSelector((state: any) => state.layout.bankLogo);
  const bankDtl: any = getBankData();
  const [organizationData, setOrganizationData] = useState<any>([]);
  const [token, setToken] = useState<string>("");
  const [submitEnabled, setSubmitEnabled] = useState<boolean>(bankDtl?.CaptchaVersion === "V3" ? true : false);
  const executeRecaptcha = useRecaptchaV3(bankDtl?.CaptchaVersion === "V3" ? bankDtl?.SiteKey : "", bankDtl?.CaptchaType);
  const [isCaptchaLoader, setIsCaptchaLoader] = useState<boolean>(false);
  const [captchaDtl, setCaptchaDtl] = useState<any>(null);

  useEffect(() => {
    if (token.length) {
      setSubmitEnabled(true);
    }
  }, [token])

  const handleToken = (token: string) => {
    setToken(token);
  };

  const getRegularCaptcha = async () => {
    if (bankDtl?.CaptchaType === "R") {
      setIsCaptchaLoader(true);
      const data = await getCaptchaCode()
      setIsCaptchaLoader(false);
      setCaptchaDtl(data);
    }
  }


  useEffect(() => {
    getRegularCaptcha();
  }, [bankDtl?.CaptchaType]);


  useEffect(() => {
    if (state === null && bankDtl?.ClientLoginType !== "Y") {
      navigate('/');
    }
  }, [state]);

  const fetchOrganizationList = async () => {
    try {
      const payload = {
        BankCode: bankDtl?.BankCode
      };
      const config = {};
      await makeRequest('POST', urls.getOrganizationCombo, payload, config).then((result) => {
        if (result.STATUS === '0') {
          const response = result.RESPONSE;
          setOrganizationData(response);
        }
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Get organization dropdown", "N");
      }
    }
  };

  useEffect(() => {
    if (bankDtl?.ClientOrgShow === "Y") {
      fetchOrganizationList();
    }
  }, [])

  const registration = async (val: any, resetForm: any) => {
    var reCaptchaToken: any;

    try {
      setIsLoader(true);

      if (bankDtl?.CaptchaVersion === "V3" && bankDtl?.CaptchaType === "G") {
        reCaptchaToken = await executeRecaptcha("login");
      };

      const payload = {
        BankCode: bankDtl?.BankCode,
        UserName: val.username,
        OrganizationCode: val.organizationValue,
        MobileNo: val.mobileNo,
        CustomerName: val.personNm,
        EmailId: val.emailId,
        Token: state?.response?.OtpToken || "",
        CaptchaType: bankDtl?.CaptchaType,
        CaptchaToken: bankDtl?.CaptchaType === "G" ? bankDtl.CaptchaVersion === "V3" ? reCaptchaToken : token : "",
        CaptchaCode: bankDtl?.CaptchaType === "R" ? val.enterCaptcha : "",
        CaptchaSessionId: bankDtl?.CaptchaType === "R" ? captchaDtl?.sessionId : "",
      };

      const config = {};

      await makeRequest("POST", urls.addCustomer, payload, config).then((result) => {
        if (result.STATUS === '0') {
          toastNotify(result.MESSAGE, 'success');
          navigate("/otp", {
            state: {
              response: result?.RESPONSE ? { ...state?.response, ...payload, Flag: 'Register', ...result?.RESPONSE[0] } : { ...state?.response, ...payload, Flag: 'Register' }
            },
          });
        } else {
          resetForm();
          getRegularCaptcha();
          toastNotify(result.MESSAGE, 'error');
        }
      }).catch((error) => {
        toastNotify(error, "error");
      });
    } catch (error) {
      await exceptionLog(error, "Add customer", "Y");
    } finally {
      setIsLoader(false);
    }
  }


  const initialValues = {
    organizationValue: "",
    organizationLabel: "",
    username: "",
    mobileNo: state?.response?.MobileNo || "",
    personNm: '',
    emailId: '',
    enterCaptcha: "",
  }

  const validation = Yup.object({
    organizationValue: bankDtl?.ClientOrgShow === "Y" ? Yup.string().required('Organization is required field') : Yup.string(),
    username: bankDtl?.ClientLoginType === "Y" ? Yup.string().required('Username is required field') : Yup.string(),
    mobileNo: Yup.string().max(10, 'Mobile No. must be 10 characters').min(10, 'Mobile No. must be 10 characters').required('Mobile No. is required field'),
    personNm: Yup.string().required('Person Name is required field'),
    emailId: (state?.response?.MailMandatoryStatus === "Y" || bankLogo.MailMandatoryStatus === "Y") ? Yup.string().email('Email id must be a valid email').required('Email id is required field').matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Must have valid email id') : Yup.string().email('Email id must be a valid email').matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Must have valid email id'),
    enterCaptcha: bankDtl?.CaptchaType === "R" ? Yup.string().required('Captcha is required field') : Yup.string(),
  });

  return (
    <>
      <div className="bg-login"></div>
      <div
        style={{ height: "100vh" }}
        className="d-flex justify-content-center align-items-center flex-column"
      >
        <Card style={{ minWidth: "350px", width: "60%" }}>
          <Card.Body>
            <Row>
              <Col
                md={6}
                className="d-none d-md-flex"
                style={{ flexDirection: "column", justifyContent: "center" }}
              >
                <LoginContantData className="my-5" />
              </Col>
              <Col md={6}>
                <div className="regitrasationFormContainer">
                  <div className="company-logo d-flex justify-content-center my-3">
                    <img
                      src={bankLogo.loginLogo}
                      alt="company-logo"
                      style={{ width: bankLogo.loginLogoWidth, height: bankLogo.loginLogoHeight }}
                    />
                  </div>

                  <div className="d-flex fw-bold mt-4 justify-content-center gap-1">
                    <HelpdeskIcon style={{}} />
                    <h3 className="border-start border-3 ps-2 text-lg text-center">
                      Customer Details
                    </h3>
                  </div>

                  <Formik
                    initialValues={initialValues}
                    validationSchema={validation}
                    onSubmit={(values, { resetForm }) => {
                      registration(values, resetForm)
                    }}
                  >
                    {({ values, handleChange, handleBlur, handleSubmit, setFieldValue }) => {
                      return (
                        <form action="#" className="mt-4" onSubmit={handleSubmit}>
                          <div className="d-grid row-gap-1">
                            {bankDtl?.ClientOrgShow === "Y" &&
                              <div >
                                <SelectField
                                  name="organizatin"
                                  required
                                  options={[
                                    { value: "", label: "Select Organization" },
                                    ...organizationData.map((items: any) => ({
                                      value: items.TranCode,
                                      label: items.OrgnaizationName
                                    }))]}
                                  // isLoading={isComboLoader}
                                  tabIndex={1}
                                  placeholder="Organization"
                                  value={values.organizationValue !== '' && {
                                    value: values.organizationValue,
                                    label: values.organizationLabel,
                                  }}
                                  onChange={(e: any) => {
                                    setFieldValue("organizationValue", e?.value);
                                    setFieldValue("organizationLabel", e?.label);
                                  }}
                                />
                                <ErrorMessage name="organizationValue" className='error-msg' component="div" />
                              </div>
                            }
                            {bankDtl?.ClientLoginType === "Y" &&
                              <div className="mt-2">
                                <Textfield
                                  label="Username"
                                  name="username"
                                  id="username"
                                  size="small"
                                  tabIndex={2}
                                  maxLength={25}
                                  required
                                  disabled={isLoader}
                                  value={values.username}
                                  onChange={(e) => setFieldValue("username", e.target.value.trim())}
                                  onBlur={handleBlur}
                                  IconProp={BiUser}
                                />
                                <ErrorMessage name="username" className='error-msg' component="div" />
                              </div>
                            }
                            <div className="mt-2">
                              <Textfield
                                label="Mobile No"
                                name="mobileNo"
                                id="mobileNo"
                                size="small"
                                required
                                readOnly={bankDtl?.ClientLoginType !== "Y"}
                                tabIndex={3}
                                maxLength={10}
                                value={values.mobileNo}
                                onChange={(e) => {
                                  e.preventDefault();
                                  const { value } = e.target;
                                  const regex = /^[0-9]*[.,]?[0-9]*$/;
                                  if (regex.test(value.toString())) {
                                    setFieldValue("mobileNo", value);
                                  }
                                }}
                                onBlur={handleBlur}
                                IconProp={BiPhone}
                              />
                              <ErrorMessage name="mobileNo" className='error-msg' component="div" />
                            </div>

                            <div className="mt-2">
                              <Textfield
                                label="Person Name"
                                name="personNm"
                                id="personNm"
                                size="small"
                                required
                                tabIndex={4}
                                maxLength={50}
                                value={values.personNm}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                IconProp={BiUser}
                              />
                              <ErrorMessage name="personNm" className='error-msg' component="div" />
                            </div>

                            <div className="mt-2">
                              <Textfield
                                label="Email Id"
                                type="email"
                                name="emailId"
                                id="emailId"
                                size="small"
                                tabIndex={5}
                                required={state?.response?.MailMandatoryStatus === "Y" || bankLogo.MailMandatoryStatus === "Y"}
                                maxLength={100}
                                value={values.emailId}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                IconProp={BiEnvelope}
                              />
                            </div>
                            <ErrorMessage name="emailId" className='error-msg' component="div" />
                          </div>

                          {bankDtl?.CaptchaType === "R" &&
                            <Row className="mt-3">
                              <Col md={6}>
                                <div className="d-flex">
                                  <div className="form-control form-control-sm p-1 capcha-input"
                                    style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0, backgroundColor: "#f0f0f0", height: 35 }}>
                                    <img src={captchaDtl?.captchaImage ? "data:image/jpeg;base64," + captchaDtl?.captchaImage : undefined} alt="captcha" className="w-100 h-100" />
                                  </div>
                                  <Button variant='orange' disabled={isCaptchaLoader} type="button" className="btn-sm" style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                    onClick={() => {
                                      getRegularCaptcha();
                                    }}>
                                    {isCaptchaLoader ? <BiLoader className="bx-spin text-white text-lg" /> : <BiRefresh className='text-white text-lg' />}
                                  </Button>
                                </div>
                              </Col>
                              <Col md={6} className="mt-md-0 mt-3">
                                <Textfield
                                  label="Captcha"
                                  name="enterCaptcha"
                                  id="enterCaptcha"
                                  size="small"
                                  tabIndex={6}
                                  maxLength={8}
                                  required
                                  disabled={isLoader}
                                  value={values.enterCaptcha}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                                <ErrorMessage name="enterCaptcha" className='error-msg' component="div" />
                              </Col>
                            </Row>
                          }

                          {bankDtl && bankDtl?.CaptchaType === "G" &&
                            <div>
                              {bankDtl?.CaptchaVersion === "V2" &&
                                <RecaptchaV2 sitekey={bankDtl?.SiteKey} callback={handleToken} />
                              }
                            </div>
                          }

                          <div className="mt-4">
                            <Button
                              type="submit"
                              className="w-100"
                              variant="orange"
                              disabled={bankDtl.CaptchaVersion === "V2" ? !submitEnabled : isLoader ? isLoader : false}
                              tabIndex={7}
                            >
                              {!isLoader ? 'Register' : <><BiLoader className='icon-loader text-white text-lg' /> Loading...</>}
                            </Button>
                          </div>

                          <div className="text-center mt-3 text-sm">
                            <Link to="/" className='ms-1' >
                              Click here back to go login
                            </Link>
                          </div>
                        </form>
                      )
                    }}
                  </Formik>
                </div>
              </Col>
            </Row>
            <hr />
            <div className="mb-0 text-xs text-slate-700 text-center">
              <BiPhone /> +91-{bankDtl?.MobileNo} | <BiEnvelope /> {bankDtl?.EmailId}
            </div>
            <div className="mb-0 text-xs text-slate-700 text-center" >
              <BiSolidMapPin /> Registration Address : {bankDtl?.Address}, {bankDtl?.CityName}, {bankDtl?.StateName} - {bankDtl?.PinCode}
            </div>
            <div className="mt-2">
              <p className="text-xs text-center mb-0">
                Developed by {" "}
                <Link to="https://suretytelco.com/" target="_blank">
                  SURETY-TELCO
                </Link>
                {" "} | {" "}
                Sales by {" "}
                <Link to="https://soft-techsolutions.com/" target="_blank">
                  SOFT-TECH SOLUTION
                </Link>
              </p>
              <p
                className="mt-1 text-xs text-center mb-0"
              >
                Copyrights © 2014 - {new Date().getFullYear()}
                {" "} | {" "}
                All Right Reserved
              </p>
            </div>
          </Card.Body>
        </Card>

        <div className="position-absolute d-flex align-items-center" style={{ top: 20, right: 20 }}>
          <div
            className="login-icon rounded-circle ms-2"
            onClick={() => dispatch(handleDark(!isDark))}
          >
            {isDark ? <BiSun /> : <BiMoon />}
          </div>
        </div>

        {/* {isLanguage && (
          <Langauge languageRef={languageRef} isLanguage={isLanguage} className='login-language' />
        )} */}

      </div>
    </>
  );
};

export default Registration;
